import React,{useState, useEffect} from 'react';
import ComponentOption from '../listaProductos/contanerOptions/ComponentOption';
import {motion, AnimatePresence} from 'framer-motion';
import LoadComponent from '../../utils/loadingComponent/loadingComponent';
import URL from '../../config/config-server-api'
import axios from 'axios';
import './showListProducts.css'
import EditProduct from './editProduct';
import { format } from 'timeago.js';
import UploadFilePhotoProduct from './uploadFilePhotoProduct';
import CreateProduct from './createProduct';

import LoadingSendAndScreenLock from '../../utils/loadingsendWithScreenLock/loadingSendWithScreenLock';

const ShowListProducts =()=>{

    const [dataProducts, setDataProducts] = useState([]);
    const [dataTienda,setDataTienda] = useState();
    const [response, setResponse] = useState(false);
    const [product, setProduct] = useState(0)
    const [modal, setModal] = useState(false);
    const [modalUpload, setModalUpload] = useState(false)

    const [loadingSate, setLoadingState] =useState(false)

    // create new product
    const [showModalProduct, setShowModalProduct]=useState(false);


    const [idProduct,setIdProduct]=useState('111111');
    const [nameImage,SetNameImage]=useState('');

    // message: the use do not created shpe
    const [verifyCreatedShope, setVerifyCreatedShope] = useState(false);

    const myRef = React.createRef();

    const myRefDescription = React.createRef();

    // const state product
    // const [stateProdcut, setStateProduct] = useSatate();

    useEffect(async ()=> {
        const userData =await JSON.parse(localStorage.getItem('dataUser'));
        
        const url1 = URL.UrlDetailTienda + userData._id
        const dTiedna = await axios.get(url1);
        setDataTienda(dTiedna.data)

        console.log(dTiedna)

        if(dTiedna.data===""){
            setVerifyCreatedShope(true);
        }

        var url2 = URL.UrlShowListAllProducts+dTiedna.data._id+'&order=asc/owner'
        console.log(url2)
        const params = {
            method:'GET',
            url:url2
        }

       axios(params)
       .then(res=>{
        console.log(res)
        setDataProducts(res.data.listProducts);
        setResponse(true);

       })
       .catch(err=>{
           console.log(err?.response?.data)
       })

    }, []);

    const editProduct =({i})=>{
        setProduct(i)
        setModal(true)
        // myRef.current.classList.toggle('hidden');
        console.log(myRef)
        console.log(dataProducts[i]);
    }

    const editPrductFile=({i})=>{
        setProduct(i)
    }

    const clouseModal=()=>{
        // myRef.current.classList.toggle('hidden');
        setModal(false)
    }

    const UpdataEdited =({DataProduct})=>{
        console.log('paretn data')
        console.log(DataProduct)
        console.log(dataProducts)
        
        const productoAct = dataProducts.slice(0);
        productoAct[product]= DataProduct;
        setDataProducts(
            productoAct
        )
        console.log(dataProducts)

    }


    const showModalUpload =()=>{
        setModalUpload(!modalUpload)
    }

    const showModalCreateP=async()=>{
        var position = await dataProducts.length?dataProducts.length:0;
        setProduct(position)
        setShowModalProduct(!showModalProduct);
        
    }



    const handleStateProduct =async (e,item,dProduct)=>{
        // console.log('receitemved in handle state product');
        // console.log(e.target.checked);
        // console.log(item)
        // console.log(dProduct);
        setLoadingState(true)
        // console.log(produscts)
        var url = `${URL.UrlUpdateSateProduct}${dProduct._id}`;
        var data = {
            state:await !(dProduct.state)
        }
        var params = {
            method:'PUT',
            url:url,
            data:JSON.stringify(data),
            headers:{
                'Content-Type':'application/json'
            }
        }

        axios(params)
        .then(data=>{
            console.log(data)
            if(data.status===200){
                var produscts =  dataProducts.splice(0)
                produscts[item].state = !dProduct.state
                setDataProducts(
                    produscts
                )
                setLoadingState(false)
        
            }
        })
        .catch(err=>{
            console.log(err)
            setLoadingState(true)
        })
        

    }

    const [description, setDescription]=useState('hiddes');
    // view deatil description products
    const showDetail =(item)=>{
        console.log(item);
        if(item!=description){
            setDescription(item)
        }else{
            setDescription('hidden')
        }
        
        console.log(description)
        // myRef.current.classList.toggle('hidden');
        // console.log(item);
        // console.log(myRefDescription); 
        // var element = document.getElementById(`${item}`)
        // console.log(element.className.indexOf('hidden'));
        // if(element.className.indexOf('hidden')== -1){
            
        //     element.className+="hidden"
        // }else{
        //     element.className = element.className.replace("hidden","")
        // }
        // console.log(element.className.indexOf("hidde"));
        // myRefDescription.current.classList.toggle('hidden')

    }

    if(!response){
        if(verifyCreatedShope){
            return  <ComponentOption>
                <motion.div initial={{opacity:0,y:100}} animate={{opacity:1,y:0}} className="bg-gray-200 rounded-xl px-1 sm:px-3 py-3" >
                        <p className="text-yellow-500 font-bold" >Para poder añadir un producto primero debe crear la tienda virtual, para ello haga clic en la seccion de inicio.</p>
                        <hr className="my-2" style={{borderTop:'1px solid #bbb'}} />
                        Esta sección te permite agregar un nueva producto o servicio a tu tienda online, los datos proporcionados 
                        del producto seran mostrados en la plataforma a todos nuestros clientes. <br/>
                        <hr className="my-2" style={{borderTop:'1px solid #bbb'}}/>
                        <p className="leading-none pb-3">
                            {/* Para agragar un nuevo producto solo preciona en el boton que dice "Agregar Nuevo Producto" */}
                        </p>
                    </motion.div>
            </ComponentOption>
        }else{
            return<ComponentOption className="p-0"> 
            <LoadComponent></LoadComponent>
            </ComponentOption>
        }     
    }else{
    return(
        <ComponentOption>
          <div className="container-showlistproducts">
          <motion.h2 initial={{x:12, opacity:0}} animate={{x:0, opacity:1}} className="text-xl font-bold uppercase pl-3 pt-5">productos</motion.h2>
            <div className="container p-1 sm:pl-10 mb-20    ">
                    <div className="bg-gray-200  rounded-2xl p-2 w-auto lg:w-9/12">
                    {
                        dataProducts?.length===0?
                        <motion.div initial={{opacity:0,y:100}} animate={{opacity:1,y:0}} className="px-1 sm:px-3 py-3" >
                            Esta sección te permite agregar un nueva producto o servicio a tu tienda online, los datos proporcionados 
                            del producto seran mostrados en la plataforma a todos nuestros clientes. <br/>
                            <hr className="my-2" style={{borderTop:'1px solid #bbb'}}/>
                            <p className="leading-none pb-3">
                                Para agragar un nuevo producto solo preciona en el boton que dice "Agregar Nuevo Producto"
                            </p>

                        </motion.div>
                        :''
                    }
                        {
                            dataProducts.length>=1?
                            dataProducts.map((d,i)=>{
                                return(
                                    <motion.div initial={{apacity:0,x:20}} animate={{opacity:1,x:0}} key={d._id} className="m-2 mb-5 p-1">
                                        <div className=" bg-gray-100 flex flex-col p-1 shadow-lg  rounded-xl border border-green-300">
                                            <div >
                                                <div className=" flex flex-rows justify-between sm:bg-gray-100 bg-gray-300 rounded-2xl flex flex-row border border-3">
                                                    <div className="flex flex-rows pl-2">
                                                        <span className="pt-1 mr-1 hidden sm:block font-semibold">Producto: </span>
                                                        <h3 className="text-lg text-green-600  font-semibold"> {d.nameProduct}</h3>
                                                    </div>
                                                    <div className="flex justify-between px-2">
                                                        <label className=" my-auto switch">
                                                            <input onChange={(e)=>handleStateProduct(e,i,d)} type="checkbox" name="state" checked ={d.state}  />
                                                            <div className="slider round"></div>

                                                        </label>
                                                    </div>
                                                </div>
                                                
                                                {
                                                    loadingSate?
                                                    <LoadingSendAndScreenLock />
                                                    :''
                                                }
                                                 
                                                
                                                <div><span className="text-gray-700 font-semibold">Piezas disponibles:</span><span className="text-gray-800"> {d.piezasDiponibles}</span></div>

                                                <div><span className="text-gray-700 font-semibold">Precio anterior (costaba) :</span><span className="text-gray-800 line-through"> {d.priceBefore} Bs.</span></div>
                                                <div><span className="text-gray-700 font-semibold">Precio de venta:</span><span className="text-gray-800"> {d.priceCurrent} Bs.</span></div>
                                                
                                                <div><span className="text-gray-700 font-semibold">Envios desde :</span><span className="text-gray-800"> {d.envioDesde}</span></div>
                                                <div><span className="text-gray-700 font-semibold">Tipo de envio :</span><span className="text-gray-800"> {d.tipoEnvio}</span></div>
                                                <div><span className="text-gray-700 font-semibold">Costo del envio :</span><span className="text-gray-800"> {d.costoEnvio} Bs.</span></div>
                                                
                                                <div>
                                                    <div onClick={()=>showDetail(i)} className="cursor-pointer text-green-300 hover:text-green-500 w-auto"> Ver mas detalles... <span className="font-bold"></span></div>
                                                  {
                                                      description==i
                                                      ?
                                                        <motion.div initial={{opacity:0,y:-12}} animate={{opacity:1,y:0}} ref={myRefDescription} id={i} className="">
                                                        <div>
                                                        <span className="text-gray-700 font-semibold">Nombre de la tienda :</span>
                                                        <span className="text-gray-800"> {d.nameTienda}</span> 
                                                         </div>
                                                        <div><span className="text-gray-700 font-semibold">Estado del producto:</span><span className="text-gray-800"> {d.estadoProduct}</span></div>

                                                        <div><span className="text-gray-700 font-semibold">Colores disponibles :</span><span className="text-gray-800"> {d.colorsAvailable}</span></div>
                                                        <div><span className="text-gray-700 font-semibold">Marca del producto:</span><span className="text-gray-800"> {d.marcaproduct}</span></div>
                                                        <div><span className="text-gray-700 font-semibold">Creado :</span><span className="text-gray-800"> {format(d.fechaRegistro,"es_ES")}</span></div>
                                                
                                                        <span  className=" text-gray-700 font-semibold">Descripción del producto o servicio:</span><span className="text-gray-800"> {d.descripcion}</span>
                                                        </motion.div>
                                                      :
                                                      ''
                                                  }
                                                </div>
                                                
                                            </div>
                                            <div className="text-gray-500 text-base mt-5 mb-3">Imganes disponibles del producto</div>
                                            <div className=" w-auto md:w-full lg:w-5/6 grid grid-flow-col grid-col-1 grid-row-1 gap-1">
                                                <div id="parent-images-owner-product" className="relative block shadow border border-gray-300">
                                                    {
                                                        d.fotoProducto===''?
                                                        <svg  id="image-producto-owner" className="w-full h-full text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                        </svg>
                                                        :
                                                        <img className="" src={d.fotoProducto} alt=""/>
                                                    }
                                                    <div id="image-number" className="absolute  top-0 left-0 text-green-500">1</div>
                                                    <div onClick={()=>{showModalUpload(); setIdProduct(d._id); SetNameImage("fotoproducto"); editPrductFile({i})}} className="absolute px-3 rounded m-1 bottom-0 right-0 bg-gray-600 hover:bg-gray-500 bg-opacity-50 ">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                                                            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                                        </svg>
                                                    </div>
                                                </div>
                                                <div id="parent-images-owner-product" className="relative block shadow border border-gray-300">
                                                    {
                                                        d.fotoProducto2===''?
                                                        <svg  id="image-producto-owner" className="w-full h-full text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                        </svg>
                                                        :
                                                        <img className="w-full h-full" src={d.fotoProducto2} alt=""/>
                                                        
                                                        
                                                    }
                                                    <div id="image-number" className="absolute  top-0 left-0 text-green-500">2</div>
    
                                                    <div onClick={()=>{showModalUpload(); setIdProduct(d._id); SetNameImage("fotoproducto2");editPrductFile({i})}} className="absolute px-3 rounded m-1 bottom-0 right-0 bg-gray-600 hover:bg-gray-500 bg-opacity-50 ">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                                                            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                                        </svg>
                                                    </div>
                                                </div>
                                                <div id="parent-images-owner-product" className="relative block shadow border border-gray-300">
                                                    {
                                                        d.fotoProducto3===''?
                                                        <svg  id="image-producto-owner" className="w-full h-full text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                        </svg>
                                                        :
                                                        <img className="" src={d.fotoProducto3} alt=""/>
                                                    }
                                                    <div id="image-number" className="absolute  top-0 left-0 text-green-500">3</div>
                                                    <div onClick={()=>{showModalUpload(); setIdProduct(d._id); SetNameImage("fotoproducto3");editPrductFile({i})}} className="absolute px-3 rounded m-1 bottom-0 right-0 bg-gray-600 hover:bg-gray-500 bg-opacity-50 ">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                                                            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                                        </svg>
                                                    </div>
                                                </div>
                                                <div id="parent-images-owner-product" className="relative block shadow border border-gray-300">
                                                    {
                                                        d.fotoProducto4===''?
                                                        <svg  id="image-producto-owner" className="w-full h-full text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                        </svg>
                                                        :
                                                        <img className="" src={d.fotoProducto4} alt=""/>
                                                    }
                                                    <div id="image-number" className="absolute  top-0 left-0 text-green-500">4</div>
                                                    <div onClick={()=>{showModalUpload(); setIdProduct(d._id); SetNameImage("fotoproducto4");editPrductFile({i})}} className="absolute px-3 rounded m-1 bottom-0 right-0 bg-gray-600 hover:bg-gray-500 bg-opacity-50 ">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                                                            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                                        </svg>
                                                    </div>
                                                </div>
                                              {/* <img src="https://prod-latintienda-s3.s3.amazonaws.com/products/10115/zQ05riDLtgEWchdErrnbk0p0kY50ezuCZEMNgfYo.jpg" alt=""/> */}
                                              {/* <img src="https://prod-latintienda-s3.s3.amazonaws.com/products/3673/thumbnails/gHPDxcwF9NmpvpF1rAJg8vkqg5nJs48fZpgkd2Sq.png" alt=""/> */}
                                              {/* <img src="https://prod-latintienda-s3.s3.amazonaws.com/products/3117/thumbnails/fxgqgPIp6ZnyANGGz69IpCLfO1qvlQMFUSe9fFZE.png" alt=""/> */}
                                            </div>
                                            <div className="pt-10 pb-4 flex flex-row-reverse">
                                             <button onClick={()=>editProduct({i})} className="bg-green-500 hover:bg-green-400  focus:outline-none px-10 px-10 mx-2 sm:mx-8 rounded-2xl text-white font-semibold">Editar </button>
                                            </div>
                                        </div>
                                    </motion.div>
                                )
                            })
                            :''
                        }
                    </div>

                    {
                        modal?
                        <div ref={myRef} className="">
                            <EditProduct product={dataProducts[product]} clouseModal={clouseModal} itemProduct={product} UpdataEdited={UpdataEdited} ></EditProduct>
                        </div>
                        :''
                    }
                    {/* -- upload file -- */}
                    {
                        modalUpload?
                        <div  className="">
                            <UploadFilePhotoProduct showModalUpload={showModalUpload} idProduct={idProduct} nameImage={nameImage} UpdataEdited={UpdataEdited}  />
                        </div>
                        :
                        ''
                    }

                    <div className="grid justify-items-center sm:justify-items-end w-100 lg:w-9/12 text-sm mt-10">
                    
                        <motion.button whileTap={{scale:0.97}}  onTap={()=>showModalCreateP()} className="bg-green-600 w-80  rounded-xl hover:bg-green-500 py-2 px-4 my-3 focus:outline-none text-white font-bold ">
                            <i className="pr-2 fas fa-plus"></i>
                            Agregar nuevo producto
                        </motion.button>
                    </div>
                    {/* create product */}
                    {
                        showModalProduct?
                        <div>
                            <CreateProduct setShowModalProduct={setShowModalProduct} showModalProduct={showModalProduct} dataTienda={dataTienda} UpdataEdited={UpdataEdited}  />
                        </div>
                        :
                        ''
                    }

                </div>
          </div>
        </ComponentOption>
    ) }
}


export default ShowListProducts